/* Library administration. Uses the portal's existing tokens. */

.name {
  font-weight: 500;
  color: var(--text);
}

.sub {
  margin-top: 2px;
  font-size: var(--text-xs);
  color: var(--text-muted);
}

.rowActions {
  display: inline-flex;
  gap: 8px;
  justify-content: flex-end;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Opening and closing sit together: they are both-or-neither, and splitting
   them across the form would hide that they are one decision. */
.times {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.hint {
  margin: -8px 0 0;
  font-size: var(--text-xs);
  color: var(--text-muted);
  line-height: 1.45;
}

.formActions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 4px;
}

@media (max-width: 480px) {
  .times {
    grid-template-columns: 1fr;
  }
}
